app.service('basketFocus', function (modal) {
	function focusAndScroll(params) {
		function focus($el, type) {
			if ($el.length) {
				console.log('Focus w element ' + type, $el);
				$el.focus().addClass('focus');
				//scrollTo.run($el, -100);
			} else {
				console.log('Nie znaleziono elementu do focusa ' + type, $el);
			}
		}
		if (params && !modal.isOpen()) {
			if (params.type == 'change-delivery-type' && params.deliveryType) {
				let $el = $('.js-delivery-type[value=' + params.deliveryType + ']');
				if (params.deliveryType == '0') {		// 0 - do sklepu
					$el = $el.filter('[data-shop-payment-type=' + params.shopType + ']');
				}
				$el = $el.closest('.radio-css').first();
				focus($el, params.type);
			} else if (params.type == 'remove-product') {
				const $box = $('#cart-summarize').children('package-box, .product-box');
				const index = $box[params.index] ? params.index : params.index - 1;
				const $el = $box.eq(index).find('.product-name').first();
				focus($el, params.type);
			} else if (params.type == 'increase-product' && params.main) {
				const $el = $('.js-change-quantity[data-product=' + params.main + ']:visible').nextAll('.js-increase-product:visible').first();
				focus($el, params.type);
			} else if (params.type == 'decrease-product' && params.main) {
				const $el = $('.js-change-quantity[data-product=' + params.main + ']:visible').nextAll('.js-decrease-product:visible, .js-delete-product:visible, .js-delete-suite:visible').first();
				focus($el, params.type);
			} else if (params.type == 'remove-suite') {
				const $box = $('#cart-summarize').children('package-box, .product-box');
				const index = $box[params.index - 1] ? params.index - 1 : params.index;
				const $el = $box.eq(index).find('.product-name').first();
				focus($el, params.type);
			} else if (params.type == 'change-quantity' && params.main) {
				const $el = $('.js-change-quantity[data-product=' + params.main + ']:visible').first();
				focus($el, params.type);
			} else if (params.type == 'basket-services-modal-add') {
				const $el = $('.services-group[data-main-item-id=' + params.main + '][data-group=' + params.group + '] .services-change').first();
				focus($el, params.type);
			} else if (params.type == 'basket-services-modal-remove') {
				const $el = $('.services-group[data-main-item-id=' + params.main + '][data-group=' + params.group + ']').find('.service-more-button, .services-change').first();
				focus($el, params.type);
			} else if (params.type == 'basket-services-modal-update') {
				const $el = $('.services-group[data-main-item-id=' + params.main + '][data-group=' + params.group + '] .services-change').first();
				focus($el, params.type);
			} else if (params.type == 'basket-partner-subscription-modal-add') {
				const $el = $('.partner-subscription[data-product=' + params.productId + '][data-group=' + params.group + '] .services-change').first();
				focus($el, params.type);
			} else if (params.type == 'basket-partner-subscription-modal-remove') {
				const $el = $('.partner-subscription[data-product=' + params.productId + '][data-group=' + params.group + ']').find('.services-change, .service-more-button').first();
				focus($el, params.type);
			} else if (params.type == 'basket-partner-subscription-modal-update') {
				const $el = $('.partner-subscription[data-product=' + params.productId + '][data-group=' + params.group + '] .services-change').first();
				focus($el, params.type);
			} else if (params.type == 'add-dependent-product') {
				const $el = $('.product-box .product-name').first();
				focus($el, params.type);
			} else if (params.type == 'remove-warranty' && params.main) {
				const $el = $('#itemId-' + params.main).nextAll('.warranties').find('.js-warranty-edit .warranty-add').first();
				focus($el, params.type)
			} else if (params.type == 'add-warranty' && params.main && params.id) {
				const $el = $('.product-box #itemId-' + params.main).nextAll('.warranties').find('.js-warranty-edit[data-id=' + params.id + '] .change').first();
				focus($el, params.type)
			} else if (params.type == 'relatedAccessories' && params.productId) {
				const $el = $('.product-box .product-name').first();
				focus($el, params.type)
			} else if (params.type == 'relatedAccessories-modal' && params.productId) {
				const $el = $('.product-box .product-name').first();
				focus($el, params.type)
			} else if (params.type == 'price-format-normal') {
				focus($('#price-version .js-price-normal').closest('label'), params.type)
			} else if (params.type == 'price-format-installment') {
				focus($('#price-version .js-price-installment').closest('label'), params.type)
			} else if (params.type == 'add-voucher' || params.type == 'remove-voucher') {
				const $checkbox = $('.js-voucher-checkbox[value=' + params.voucher + ']');
				if ($checkbox.length) {
					focus($checkbox.closest('label'), params.type)
				} else {
					focus($('.js-toggle-manual-voucher'), params.type)
				}
			} else if (params.type == 'set-instalment-option') {
				const $el = $('#preview-list .js-show-instalment-calculator').first();
				focus($el, params.type)
			}
		}
	}

	return {
		focusAndScroll
	};
});
